import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class ErrorsController extends Controller {
  @service history!: History;
  @service router!: RouterService;

  browserCryImage = new URL('cio/assets/images/browser-cry.svg', import.meta.url).toString();

  @action
  back() {
    if (document.referrer === '') {
      this.router.transitionTo('authenticated');
    } else {
      this.history.back();
    }
  }
}
